import { render, staticRenderFns } from "./AdminUtils.vue?vue&type=template&id=22de19e6&scoped=true"
import script from "./AdminUtils.vue?vue&type=script&lang=js"
export * from "./AdminUtils.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de19e6",
  null
  
)

export default component.exports